import UISelect from "components/ui/select/UISelect";
import React from "react";

const LanguageSelect = ({
  label,
  options,
  selectedValue,
  onChange,
  isDisabled = false,
  getOptionLabel,
  fullwidth = true,
  ...props
}) => (
  <UISelect
    size="x-small"
    menuPlacement="top"
    isSearchable={false}
    label={label}
    onChange={onChange}
    options={options}
    getOptionLabel={getOptionLabel}
    selectedValues={selectedValue}
    isDisabled={isDisabled}
    fullwidth={fullwidth}
    {...props}
  />
);

export default LanguageSelect;